import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import Loading from "../../components/loading";
import ModalViewInterm from "./modals/modalViewInterm";
import ModalSearchInterm from "./modals/modalSearchInterm";
import { toast } from 'react-toastify';
//SERVICES  
import ExchangeOperationService from "../../services/exchangeOperationService";
import ListService from "../../services/listService";

function ReportOperationInterm() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const initialized = useRef(false)
    const [listOperations, setListOperations] = useState([])
    const [listOperationLinks, setListOperationLinks] = useState([])
    const [listOperationMeta, setListOperationMeta] = useState([])
    const [listStatus, setListStatus] = useState([])
    const [modalViewOpen, setModalViewOpen] = useState(false);
    const [modalSearchOpen, setModalSearchOpen] = useState(false);
    const [bonoSelected, setBonoSelected] = useState('');
    const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));
    const [listAccountManagers, setListAccountManagers] = useState([])
    const [listCurrencies, setListCurrencies] = useState([])

    // Search Form
    let defaultDate = new Date().toISOString().slice(0,10);
    const [searchModel, setSearchModel] = useState({
        account: '',
        status: 3,
        dateFrom: defaultDate,
        dateTo: defaultDate,
        manager: '',
        currency: '',
    })

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            // COMERCIAL LOW
            if(userProfile.roleid === 8){ 
                searchModel.manager = userProfile.portfolio_manager_id;
            }
            doSearch()
        }
    }, [false]);

    const doSearch = async (event) => {
        try {  
            setLoading(true)
            console.log(searchModel)
            const response = await ExchangeOperationService.getOperationSearch(searchModel)
            setListOperations(response.data)
            setListOperationLinks(response.links)
            setListOperationMeta(response.meta)
            // Status
            const responseStatus = await ListService.getStatusList()
            setListStatus(responseStatus.data)
            // Account Managers
            const responseAccountManagers = await ListService.getPortfolioManagersList()
            setListAccountManagers(responseAccountManagers.data)
            // Currencies
            const responseCurrencies = await ListService.getCurrenciesList()
            setListCurrencies(responseCurrencies.data)
        } catch (err) {
            if(err.response.status !== 401){
                Swal.fire({
                    title: 'Ooops?',
                    text: err.response.data.errors[0].detail,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{
                sessionStorage.removeItem("userProfile");
                navigate('/')
                window.location.reload();
            }
        } finally{ setLoading(false) }
    }
    
    const doExport = async () => {
        var filters = '';
        if(searchModel.dateFrom !== '' && searchModel.dateFrom !== ""){ filters += '&filter[from]='+searchModel.dateFrom; }
        if(searchModel.dateTo !== '' && searchModel.dateTo !== ""){ filters += '&filter[to]='+searchModel.dateTo; }
        if(searchModel.account !== '' && searchModel.account !== null){ filters += '&filter[account]='+searchModel.account; }
        // if(searchModel.user !== '' && searchModel.user !== null){ filters += '&filter[user]='+searchModel.user; }
        if(searchModel.status !== '' && searchModel.status !== null){ filters += '&filter[state]='+searchModel.status; }
        if(searchModel.manager !== '' && searchModel.manager !== null){ filters += '&filter[portfolioManagerId]='+searchModel.manager; }
        if(searchModel.currency !== '' && searchModel.currency !== null){ filters += '&filter[currencyExchangeTypeId]='+searchModel.currency; }
        window.open(process.env.REACT_APP_API_URL+"exchange-operations/download/excel?token="+userProfile.token+filters, '_blank')
    }

    const doView = async (obj) => {
        if(obj !== null){
            setBonoSelected(obj)
            setModalViewOpen(true)
        }
    }
   
    const doOpenModalSeacht = async () => {
        setModalSearchOpen(true)
    }

    const doPagination = async () => {
        try {  
            setLoading(true)
            const response = await ExchangeOperationService.getOperationsSearchPagination(listOperationLinks.next)
            response.data.forEach( data => listOperations.push(data) )
            setListOperationLinks(response.links)
            setListOperationMeta(response.meta)
        } catch (err) {
            if(err.response.status !== 401){
                Swal.fire({
                    title: 'Ooops?',
                    text: err.response.data.errors[0].detail,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{
                sessionStorage.removeItem("userProfile");
                navigate('/')
                window.location.reload();
            }
        } finally{ setLoading(false) }
    }

    const doDelete = async (id) => {
        Swal.fire({
            title: "Atención!",
            text: "Ud. esta seguro que quiere eliminar la operación ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            confirmButtonColor: "#83766d"
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    ExchangeOperationService.deleteIntermOperation(id)
                    .then(() => {
                        toast.success('Operación Eliminada!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                    })
                    .catch((error) => {
                        Swal.fire({
                            title: 'Ooops?',
                            text: error.response.data.errors[0].detail,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#f13939'
                        })
                    })
                    .finally(() => { doSearch() })
                } catch (error) {
                    Swal.fire({
                        title: 'Ooops?',
                        text: error.response.data.errors[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }finally{ doSearch() }
            }
        })
    }

    const doCalculator = async () => {
        if(listOperations.length > 0){
            let sum = 0
            listOperations.forEach(operation => {
                // GANANCIA EN ARS
                if(operation.exchange_type_id === 1 && (operation.currency_id === 1 || operation.currency_id === null) ){
                    if( (operation.currency_exchange_type_id === 1 || operation.currency_exchange_type_id === 3) || 
                        (operation.exchange_type_id === 2 && operation.currency_id === 1 && operation.operation_type_id === 1) ){
                        // COMPRA ARS
                        sum = sum + (operation.esco_price - operation.price) * operation.qty
                    }else if( (operation.currency_exchange_type_id !== 5 && operation.currency_exchange_type_id !== 6) ){
                        // VENTA ARS
                        sum = sum + (operation.price - operation.esco_price) * operation.qty
                    }
                }
                // GANANCIA EN DOLARES
                if(operation.exchange_type_id === 2 && operation.currency_exchange_type_id === null){
                    if(operation.operation_type_id === 1){
                        if(operation.operation_type_id === 1){
                            // COMPRA DOLARES
                            sum = sum + (operation.esco_price - operation.price) * operation.qty
                        }else{
                            // VENTA DOLARES
                            sum = sum + (operation.price - operation.esco_price) * operation.qty
                        }
                    }
                }
                // GANANCIA EN DOLARES x CANJE
                if(operation.exchange_type_id === 1){
                    if(operation.currency_exchange_type_id === 5){
                        // MEP A CABLE
                        sum = sum + ((operation.esco_price - operation.price) * operation.qty)/100
                    }else if(operation.currency_exchange_type_id === 6){
                        // CABLE A MEP
                        sum = sum + ((operation.price - operation.esco_price) * operation.qty)/100
                    }
                }
            })
            Swal.fire({
                title: 'Suma',
                text: sum,
                icon: 'success',
                confirmButtonText: 'OK',
            })
        }
    }

    if(loading){ return( <Loading></Loading> ) }

    return (
        <>
            <div className="row">
                <div className="col">
                    <h2>Reporte Operaciones de Intermediaciones { listOperationMeta.total > 0 && <span className="fontMedium">({listOperationMeta.total})</span> }</h2>
                </div>
                <div className="col">
                    <div className="btn-group float-end" role="group" aria-label="First group">
                        <button type="button" className="btn btn-outline-secondary" title="Exportar" onClick={doExport}>
                            <i className="tf-icons bx bx-export" />
                        </button>
                        <button type="button" className="btn btn-outline-secondary" title="Sumar" onClick={doCalculator}>
                            <i className="tf-icons bx bx-calculator" />
                        </button>
                        <button type="button" className="btn btn-outline-secondary" title="Buscar" onClick={doOpenModalSeacht } >
                            <i className="tf-icons bx bx-filter" />
                        </button>
                    </div>
                </div>
            </div>

            <div className="row">
                <table className="table table-striped table-hover" >
                    <thead style={{backgroundColor: '#FFFFFF'}}>
                        <tr className="text-nowrap">
                            <th>#</th>
                            <th>Fecha</th>
                            <th>Comintente</th>
                            <th>Comercial</th>
                            <th>Moneda</th>
                            <th>Tipo</th>
                            <th>Segmento</th>
                            <th>Plazo</th>
                            <th>Cantidad</th>
                            <th>Precio Base</th>
                            <th>Precio Esco</th>
                            <th className="text-end">Total ESCO</th>
                            <th className="text-end">Ganancia</th>
                            <th>Contraparte</th>
                            <th>Estado</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                        {listOperations.map(operation => {
                            return (
                                <tr key={operation.id} className={(operation.is_usd_for_intermediation ? 'table-danger' : 'null')} >  
                                    <td className="small">{operation.id}</td>
                                    <td>
                                        
                                        <div className="d-flex justify-content-start align-items-center user-name">
                                            <div className="d-flex flex-column">
                                                <a className="text-body text-truncate ">
                                                    <span className="fw-medium">
                                                        {moment(operation.date).format('DD/MM/YYYY')}
                                                    </span>
                                                </a>
                                                <small className="text-muted">{moment(operation.date).format('HH:MM')}</small>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-start align-items-center user-name">
                                            <div className="d-flex flex-column">
                                                <a className="text-body text-truncate">
                                                    <span className="fw-medium">
                                                        {operation.account_model.name.length > 30 ?
                                                            `${operation.account_model.name.substring(0, 30)}...` : operation.account_model.name
                                                        }
                                                    </span>
                                                </a>
                                                <small className="text-muted"><span className="badge bg-label-dark">{operation.account_model.account}</span></small>
                                            </div>
                                        </div>
                                    </td>
                                    <td><small>{operation.portfolio_manager.name}</small></td>
                                    <td>
                                        {(operation.currency_exchange_type_id === 1 || operation.currency_exchange_type_id === 2 || operation.currency_exchange_type_id === 3 || operation.currency_exchange_type_id === 4)&& <span className="badge bg-label-info me-1">Pesos</span>}
                                        {(operation.currency_exchange_type_id === 5)&& <span className="badge bg-label-primary me-1">MEP</span>}
                                        {(operation.currency_exchange_type_id === 6)&& <span className="badge bg-label-warning me-1">CABLE</span>}
                                        {(operation.exchange_type_id === 2 && operation.currency_id === 1) && <span className="badge bg-label-info me-1">Pesos</span>}
                                        {(operation.exchange_type_id === 2 && operation.currency_id === 3) && <span className="badge bg-label-primary me-1">MEP</span>}
                                        {(operation.exchange_type_id === 2 && operation.currency_id === 2) && <span className="badge bg-label-warning me-1">CABLE</span>}
                                    </td>
                                    <td>
                                        {operation.exchange_type_id === 1 &&  
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            <span className="badge bg-label-success me-1">Moneda</span>
                                                        </span>
                                                    </a>
                                                    <small className="text-muted"><span className="badge bg-label-dark">{operation.currency_exchange_type.name}</span></small>
                                                </div>
                                            </div>
                                        }
                                        {operation.exchange_type_id === 2 &&  
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            <span className="badge bg-label-primary me-1">Instrumento</span>
                                                        </span>
                                                    </a>
                                                    <small className="text-muted">
                                                        <span className="badge bg-label-dark">{operation.ticker}</span>
                                                    </small>
                                                </div>
                                            </div>
                                        }
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-start align-items-center user-name">
                                            <div className="d-flex flex-column">
                                                <small className="text-muted">
                                                    {operation.segment_id === 1 && <span className="badge bg-label-primary me-1">{operation.segment.name}</span>}
                                                    {operation.segment_id === 2 && <span className="badge bg-label-info me-1">{operation.segment.name}</span>}
                                                    {operation.segment_id === 3 && <span className="badge bg-label-secondary me-1">{operation.segment.name}</span>}
                                                </small>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-start align-items-center user-name">
                                            <div className="d-flex flex-column">
                                                <a className="text-body text-truncate">
                                                    <span className="fw-medium">
                                                        {operation.operation_type_id === 1 && <span className="badge bg-label-success me-1">{operation.operation_type.name}</span>}
                                                        {operation.operation_type_id === 2 && <span className="badge bg-label-danger me-1">{operation.operation_type.name}</span>}
                                                    </span>
                                                </a>
                                                <small className="text-muted"><span className="badge bg-label-dark">{operation.settlement_term.name}</span></small>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-end">
                                        <NumericFormat 
                                            displayType="text" 
                                            value={operation.qty} 
                                            allowLeadingZeros thousandSeparator="." 
                                            decimalSeparator="," 
                                        /> 
                                    </td>
                                    <td className="text-end">
                                        <NumericFormat 
                                            displayType="text" 
                                            value={operation.price} 
                                            decimalScale={5} 
                                            allowLeadingZeros thousandSeparator="." 
                                            decimalSeparator="," 
                                            prefix={'$'}  
                                        /> 
                                    </td>
                                    <td className="text-end">
                                        <NumericFormat 
                                            displayType="text" 
                                            value={operation.esco_price} 
                                            decimalScale={5} 
                                            allowLeadingZeros thousandSeparator="." 
                                            decimalSeparator="," 
                                            prefix={'$'}  
                                        /> 
                                    </td>
                                    {/* AR$ */}
                                    <td className="text-end">
                                        <NumericFormat 
                                            displayType="text" 
                                            value={operation.qty * operation.esco_price} 
                                            decimalScale={5} 
                                            allowLeadingZeros thousandSeparator="." 
                                            decimalSeparator="," 
                                            prefix={'$'}  
                                        /> 
                                    </td>
                                    {/* TOTAL */}
                                    { (operation.exchange_type_id === 1 && (operation.currency_id === 1 || operation.currency_id === null) )?
                                        // GANANCIA EN ARS
                                        <>
                                                {(operation.currency_exchange_type_id === 1 || operation.currency_exchange_type_id === 3) ||
                                                    (operation.exchange_type_id === 2 && operation.currency_id === 1 && operation.operation_type_id === 1)  ?
                                                    // COMPRA ARS
                                                    (
                                                        <td className="text-end">
                                                            <NumericFormat 
                                                                displayType="text" 
                                                                value={(operation.esco_price - operation.price) * operation.qty} 
                                                                allowLeadingZeros thousandSeparator="." 
                                                                decimalSeparator=","
                                                                prefix={'$'}  
                                                                decimalScale={2} 
                                                            /> 
                                                        </td> 
                                                    )
                                                :
                                                    (operation.currency_exchange_type_id !== 5 && operation.currency_exchange_type_id !== 6)  ?
                                                    // VENTA ARS
                                                    (
                                                        <td className="text-end">
                                                            <NumericFormat 
                                                                displayType="text" 
                                                                value={(operation.price - operation.esco_price) * operation.qty} 
                                                                allowLeadingZeros thousandSeparator="." 
                                                                decimalSeparator=","
                                                                prefix={'$'}  
                                                                decimalScale={2} 
                                                            /> 
                                                        </td>
                                                    )
                                                    :null
                                                }                                 
                                        </>
                                    : null}
                                    {/* GANANCIA EN DOLARES */}
                                    { operation.exchange_type_id === 2 && operation.currency_exchange_type_id === null ?
                                        <>
                                            {(operation.operation_type_id === 1)  ?
                                                // COMPRA
                                                (
                                                    <td className="text-end">
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={(operation.esco_price - operation.price) * operation.qty} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                            decimalScale={2} 
                                                        /> 
                                                    </td>
                                                )
                                            :
                                                // VENTA 
                                                (
                                                    <td className="text-end">
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={(operation.price - operation.esco_price) * operation.qty} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                            decimalScale={2} 
                                                        /> 
                                                    </td>
                                                )
                                                
                                            }                                   
                                        </>                                            
                                    : null}
                                    {/* GANANCIA EN DOLARES x CANJE */}
                                    { operation.exchange_type_id === 1 ?
                                            <>
                                                {(operation.currency_exchange_type_id === 5)  ?
                                                    // MEP A CABLE
                                                    (
                                                        <td className="text-end">
                                                            <NumericFormat 
                                                                displayType="text" 
                                                                value={((operation.esco_price - operation.price) * operation.qty)/100} 
                                                                allowLeadingZeros thousandSeparator="." 
                                                                decimalSeparator=","
                                                                prefix={'$'}  
                                                                decimalScale={2} 
                                                            /> 
                                                        </td>
                                                    )
                                                : null}
                                                {(operation.currency_exchange_type_id === 6)  ?
                                                    // CABLE A MEP
                                                    (
                                                        <td className="text-end">
                                                            <NumericFormat 
                                                                displayType="text" 
                                                                value={((operation.price - operation.esco_price) * operation.qty)/100} 
                                                                allowLeadingZeros thousandSeparator="." 
                                                                decimalSeparator=","
                                                                prefix={'$'}  
                                                                decimalScale={2} 
                                                            /> 
                                                        </td>
                                                    )
                                                :null }                                     
                                        </>                                            
                                    : null} 
                                    <td><small>{operation.counterparty.name}</small></td>
                                    <td>
                                        {operation.operation_state_id === 1 && <span className="badge bg-label-secondary me-1">{operation.operation_state.display_name}</span>}
                                        {operation.operation_state_id === 2 && <span className="badge bg-label-warning me-1">{operation.operation_state.display_name}</span>}
                                        {operation.operation_state_id === 3 && <span className="badge bg-label-success me-1">{operation.operation_state.display_name}</span>}
                                        {operation.operation_state_id === 4 && <span className="badge bg-label-danger me-1">{operation.operation_state.display_name}</span>}
                                    </td>
                                    <td className="text-end">
                                        <div className="dropdown">
                                            <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                                <i className="bx bx-dots-vertical-rounded" />
                                            </button>
                                            <div className="dropdown-menu">
                                                <a className="dropdown-item" href="#"  onClick={() => {  doView(operation) } }>
                                                    <i className="bx bx-eyes me-1" /> Ver
                                                </a>
                                                {
                                                    (operation.operation_state_id === 3 ) &&
                                                        <a className="dropdown-item" href="#"  onClick={() => { doDelete(operation.id) } }>
                                                            <i className="bx bx-eyes me-1" /> Eliminar
                                                        </a>
                                                }
                                               
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                )
                            })
                        }

                    </tbody>
                </table>

                { listOperationLinks.next !== null ?
                        <div className="row mt-4">
                            <div className="col d-grid gap-2 d-md-flex justify-content-md-center">
                            { sending ? 
                                <div className="d-flex justify-content-center">
                                    <div className="spinner-border text-info" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            : 
                                <button type="button" className="btn btn-outline-info" onClick={doPagination}>Mas Información</button>
                            }
                            </div>
                        </div>
                    :
                        null
                }
            </div>

            {/* SEARCH */}
            <ModalSearchInterm 
                handleOpen={setModalSearchOpen} 
                isOpen={modalSearchOpen} 
                setSearch={setSearchModel}
                search={searchModel}
                doSearch={doSearch}
                listStatus={listStatus}
                listComerciales={listAccountManagers}
                listCurrencies={listCurrencies}
            />
            
            { bonoSelected !== '' &&
                <ModalViewInterm 
                    handleOpen={setModalViewOpen} 
                    isOpen={modalViewOpen} 
                    selected={bonoSelected}
                    fundId={bonoSelected.id}
                />
            }
            
        </>
     );

}

export default ReportOperationInterm;